// src/components/SmartImg.js
// Ảnh bìa (khoá học, chuyên đề, bộ đề): dùng bản .webp cùng tên (nhẹ hơn ảnh PNG 5–10 lần) nếu có,
// lỗi thì quay về ảnh gốc, rồi đến ảnh giữ chỗ. Ảnh ngoài màn hình chỉ tải khi cuộn tới (trừ eager).
// Ảnh mới trong public/course, public/topic, public/de nên kèm bản .webp; không có cũng không sao.
import React, { useEffect, useState } from "react";

const toWebp = (src) =>
  /^\/(course|topic|de)\/[^/]+\.(png|jpe?g)$/i.test(src || "")
    ? src.replace(/\.(png|jpe?g)$/i, ".webp")
    : null;

const SmartImg = ({ src, fallback, alt, className, eager = false }) => {
  const webp = toWebp(src);
  // 0: bản webp (hoặc ảnh gốc nếu không có), 1: ảnh gốc, 2: ảnh giữ chỗ
  const [stage, setStage] = useState(0);
  useEffect(() => setStage(0), [src]);

  const current = !src ? fallback : stage === 0 ? webp || src : stage === 1 ? src : fallback;
  return (
    <img
      src={current}
      alt={alt}
      className={className}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      onError={() => setStage((s) => (s === 0 && webp ? 1 : 2))}
    />
  );
};

export default SmartImg;
